module.exports = __webpack_public_path__ + "img/cup-3.75a434ab.png";